<!-- Veste BEIZY del bottom sheet, la stessa di dettaglio notifica ed evento
     fiscale: testata bianca a filo dei bordi chiusa dal tratto nero 2px, corpo
     scrollabile su fondo panna con le superfici bianche bordate, footer bianco
     riagganciato in basso dallo stesso tratto. -->
<div class="day-sheet">
  <div class="day-sheet__head">
    <div>
      <h4 class="day-sheet__title m-0">
        {{ data.date | date: 'EEEE d MMMM y' }}
      </h4>
      <p class="day-sheet__count m-0">
        @if (items().length === 1) {
          1 voce in programma
        } @else {
          {{ items().length }} voci in programma
        }
      </p>
    </div>

    <button
      mat-icon-button
      type="button"
      class="custom-button-border"
      aria-label="Chiudi il dettaglio del giorno"
      (click)="close()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="day-sheet__scroll">
  @if (items().length === 0) {
    <div class="day-sheet__empty">
      <mat-icon fontSet="material-icons-outlined">event_available</mat-icon>
      <p class="m-0">Nessun impegno in questa giornata.</p>
    </div>
  } @else {
    <ul class="day-sheet__list">
      @for (item of items(); track item.key) {
        <li
          class="day-item"
          [class.day-item--settled]="item.settled"
          [class.day-item--important]="item.important"
          [attr.data-kind]="item.kind"
        >
          <span class="day-item__icon">
            <mat-icon fontSet="material-icons-outlined">{{ item.icon }}</mat-icon>
          </span>

          <div class="day-item__body">
            <p class="day-item__title m-0">{{ item.title }}</p>
            @if (item.subtitle) {
              <p class="day-item__subtitle m-0">{{ item.subtitle }}</p>
            }
            @if (item.personalEvent?.notes; as notes) {
              <p class="day-item__notes m-0">{{ notes }}</p>
            }
            @if (item.settled) {
              <span class="day-item__flag">
                {{ item.personalEvent ? 'Completata' : 'Già pagata' }}
              </span>
            }
          </div>

          <div class="day-item__side">
            @if (item.amount) {
              <span class="day-item__amount">
                {{ item.amount | currency: 'EUR' }}
              </span>
            }

            <div class="day-item__actions">
              @if (item.invoice) {
                <button
                  mat-icon-button
                  type="button"
                  matTooltip="Apri la fattura"
                  aria-label="Apri la fattura"
                  (click)="openInvoice(item)"
                >
                  <mat-icon>chevron_right</mat-icon>
                </button>
              }
              @if (item.personalEvent; as activity) {
                <button
                  mat-icon-button
                  type="button"
                  class="day-item__check"
                  [class.day-item__check--on]="activity.is_done"
                  [matTooltip]="
                    activity.is_done
                      ? 'Segna come da fare'
                      : 'Segna come completata'
                  "
                  [attr.aria-pressed]="activity.is_done"
                  [attr.aria-label]="
                    activity.is_done
                      ? 'Segna come da fare'
                      : 'Segna come completata'
                  "
                  (click)="toggleDone(item)"
                >
                  <mat-icon fontSet="material-icons-outlined">
                    {{ activity.is_done ? 'check_circle' : 'radio_button_unchecked' }}
                  </mat-icon>
                </button>
                <button
                  mat-icon-button
                  type="button"
                  matTooltip="Modifica attività"
                  aria-label="Modifica attività"
                  (click)="editActivity(item)"
                >
                  <mat-icon fontSet="material-icons-outlined">edit</mat-icon>
                </button>
                <button
                  mat-icon-button
                  type="button"
                  matTooltip="Elimina attività"
                  aria-label="Elimina attività"
                  (click)="deleteActivity(item)"
                >
                  <mat-icon fontSet="material-icons-outlined">delete</mat-icon>
                </button>
              }
            </div>
          </div>
        </li>
      }
    </ul>
  }
  </div><!-- /day-sheet__scroll -->

  <div class="day-sheet__foot">
    <button
      matButton="filled"
      type="button"
      class="izy-button-primary custom-button-border"
      (click)="addActivity()"
    >
      <mat-icon>add</mat-icon>
      Aggiungi attività
    </button>
  </div>
</div>
